import { Injectable } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';
import { TenantMembersService } from '../services/tenant-members.service';

/**
 * Loads the current user's organogram role + permissions for the active tenant
 * into AuthService userInfo (used by chat stream RBAC).
 */
@Injectable({ providedIn: 'root' })
export class OrganogramIdentityService {
  constructor(
    private membersService: TenantMembersService,
    private authService: AuthService
  ) {}

  refresh(): void {
    if (!this.authService.isUserLoggedIn()) {
      return;
    }

    this.membersService.getMyOrganogramRole().subscribe({
      next: res => {
        const data = res?.data;
        this.authService.applyOrganogramIdentity(
          data?.organogramRoleName ?? null,
          data?.permissions ?? []
        );
      },
      error: (err) => {
        // Transient failure must not clear a role already loaded, and must
        // not turn a previous identity into open access.
        console.error('Failed to load organogram role; keeping existing identity', err);
      }
    });
  }
}
